import { getCancellationReasons } from './GetCancellationReasons';
import { submitCancellationFeedback } from './SubmitCancellationFeedback';

export const CancellationReasonsApi = {
  getCancellationReasons,
  submitCancellationFeedback,
};
